
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sources/clickhouse",
      function () {
        return require("private-next-pages/sources/clickhouse.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sources/clickhouse"])
      });
    }
  